import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import Modal from 'react-responsive-modal';
import VATCodeSimulation from '../vatCodeSimulator/VATCodeSimulation';
import VATCODE_SIMULATOR_CONTROLLER from "../../controllers/vatCodeSimulator";
import HighlightOnInAppMessage from '../inAppMessages/HighlightOninAppMessage';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import SingleCountrySelector from '../selectors/country/SingleCountrySelector.jsx';
import SingleCompanySelector from '../selectors/company/SingleCompanySelector.jsx';
import NumberField from '../fields/number/NumberField';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
import { SSelect } from '@avalara/skylab-sdk/react';

const FORM_NAME = 'VAT_CODES_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

// TODO get this static from API
const flowTypes = ['0','CRC','DIL','DIS','DRC','DRC03','DRC04','DRC05','DRC06','DRC07','DRC08','DRC09','DRC10','DRC11','DRC12','DRC13','DRC14A','DRC14B','DRC15','DRC16','DRC17A','DRC17B','DRC18','DRC19A','DRC19B','DRC98','DRC99','ERC','EXP','ICO','ICS','IMP','IMPBH','IMPKW','IMPOM','IMPQA','IMPSA','INL','INS','IRC','LOC','MPS','NRC','OSS','POC','PRC','REM','SIC','SRC','SSU','TRA','TRAAE','TRABH','TRAKW','TRAOM','TRAQA','TRASA','TRC','TRI','DST','LVG','WHT'];
const goodTypes = ['None', 'Trade goods/services', 'Miscellaneous goods/services', 'Capital assets'];
const ecListingOptions = ['No','EC Goods','Triangulation','EC Services - art. 196','Services - art. 194','Transfers','Transfers after exempted import','EC Goods after exempted import','Triang. Purch. End Customer'];
const refundVatCodeOptions = ['No', 'Refund for Invoices', 'Refund for Import Documents', 'Simplified Invoice'];
const reportingDates = ['TransactionDate', 'ClearingDate', 'InvoiceDate', 'VATDate', 'InvoiceReceiptDate'];
const mainVATCodes = ['Main VAT code','Second line VAT code', 'Third line VAT code (distance sales)', 'Recargo or local jp VAT']; //Constants indicating the possible values of field "Main VAT Code". These values have to match the possible values returned by SaaS API (see mainVATCodeReplaceValues in ReportingCombinationService.cs)
const ossOptions = ['No', 'Moss' , 'OSS Union Scheme','OSS Non-Union Scheme','OSS Import Scheme']
const MODAL_CLASSNAMES =  {
  modal: 'modal-max-width-65'
};

// Helper functions to reduce cognitive complexity

const createSyntheticEvent = (name, value) => ({
  target: { name, value }
});

const createSelectOption = (key, value, label, selected, disabled = false) => ({
  key,
  value,
  label,
  selected,
  disabled
});

const createOptionsFromArray = (options, selectedValue, keyAsValue = false) => {
  return options.map((option, index) => ({
    key: keyAsValue ? index.toString() : option,
    value: keyAsValue ? index.toString() : option,
    label: option,
    selected: keyAsValue ? selectedValue === index : selectedValue === option
  }));
};

const shouldDisableField = (mainVATCode) => {
  return mainVATCode === mainVATCodes[1];
};

const getValueOrDefault = (value, defaultValue, condition) => {
  return condition ? defaultValue : value;
};

const handleBooleanCheckbox = (checked) => checked ? true : false;

const handleBinaryCheckbox = (checked) => checked ? 1 : 0;

const handleVatRateTypeCheckbox = (checked) => checked ? 'Reversed' : 'Normal';

const ERROR_MESSAGE_FIELDS = {
  'vatCode': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_VAT_CODE,
  'combinationIDInvoice': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID,
  'combinationIDCredit': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID_CREDIT,
  'goodType': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_GOODTYPE,
  'mainVATCode': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_MAIN_VAT_CODE,
  'ivatTransactionID': ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_IVAT_TRANSACTION_ID
};

const getCheckboxValue = (field, checked) => {
  const booleanFields = ['intrastatIn', 'intrastatOut'];
  const binaryFields = ['recalculateVAT', 'reverseChargeDocument', 'revisionVATCodeTaxBConvertedToVAT', 
                        'fixedAsset', 'reversedVATRateDomestic', 'vatCodeForVATUnit'];
  
  if (booleanFields.includes(field)) {
    return { value: handleBooleanCheckbox(checked), isHandled: true };
  }
  
  if (binaryFields.includes(field)) {
    return { value: handleBinaryCheckbox(checked), isHandled: true };
  }
  
  if (field === 'vatRateType') {
    return { value: handleVatRateTypeCheckbox(checked), isHandled: true };
  }
  
  return { value: checked, isHandled: false };
};

const getSubmitAction = (createNew, duplicateVatCode) => {
  if (createNew === 'false') {
    return 'EXPERT_UPDATE';
  }
  if (createNew === 'true' && duplicateVatCode === 'true') {
    return 'EXPERT_DUPLICATE';
  }
  return 'UNKNOWN';
};

const shouldShowSimulation = (createNew, userCode) => {
  return createNew === 'false' && userCode !== 'Generic';
};

const isCreatingNew = (createNew) => createNew === 'true';

const isNotCreatingNew = (createNew) => createNew === 'false';

const getButtonLabel = (createNew) => {
  return isCreatingNew(createNew) 
    ? 'vatCodes_form_button_create' 
    : 'vatCodes_form_button_update';
};

class VatCodeForm extends Component {

  constructor(props) {
    super(props);
    this.log = new Logger(this.props.UID_FORM_NAME, LOG_LEVELS.DEBUG);
    let today = new Date(),
        date = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + today.getDate();
    this.state = {
        date: date
    };
    this.createGoodTypeOptions = this.createGoodTypeOptions.bind(this);
    this.createMainVATCodeOptions = this.createMainVATCodeOptions.bind(this);
    this.createLineFlowTypeOptions = this.createLineFlowTypeOptions.bind(this);
    this.createMiniOneStopShopOptions = this.createMiniOneStopShopOptions.bind(this);
    this.createICListingOptions = this.createICListingOptions.bind(this);
    this.createRefundVATCodeOptions = this.createRefundVATCodeOptions.bind(this);
    this.createDocumentsClearedOptions = this.createDocumentsClearedOptions.bind(this);
  }

  state = {
    open: false,
  };

  checkForSalesDomesticReverseChargeRate(flowType, vatCodeFlow) {
    const flowTypes = ["DRC", "SRC", "CRC", "MPS"];
    
    if (!flowType || !vatCodeFlow) {
      return false;
    }
    
    return vatCodeFlow.toUpperCase() === "OUT" && 
           flowTypes.includes(flowType.substring(0, 3).toUpperCase());
  }

  applyMainVATCodeLogic(fieldValues) {
    if (!fieldValues) {
      return {};
    }
    
    const mainVATCode = fieldValues.mainVATCode || "";
    const disableField = shouldDisableField(mainVATCode);
    
    return {
      mainVATCode,
      disableField,
      recalculateVAT: getValueOrDefault(fieldValues.recalculateVAT, 0, disableField),
      intrastatIn: getValueOrDefault(fieldValues.intrastatIn, false, disableField),
      intrastatOut: getValueOrDefault(fieldValues.intrastatOut, false, disableField),
      icListing: getValueOrDefault(fieldValues.icListing, ecListingOptions[0], disableField),
      refundVATCode: getValueOrDefault(fieldValues.refundVATCode, refundVatCodeOptions[0], disableField),
      disableRecalculateVAT: disableField,
      disableECListing: disableField,
      disableRefundVATCode: disableField,
      disableDocumentsCleared: disableField
    };
  }

  getTransactionDescription(fieldValues) {
    if (!fieldValues) {
      return "";
    }
    
    let transDescr = fieldValues.iVATTransactionIDDescription;
    
    if (fieldValues.noSaftCode !== "") {
      const saftCodeLabel = LANGUAGE_CONTROLLER.format(this.props.languages, 'vatCodes_form_norway_saft_code');
      transDescr += `\n${saftCodeLabel}: ${fieldValues.noSaftCode}`;
    }
    
    return transDescr;
  }
 
  onOpenModal = () => {
    this.setState({ open: true });

    let company = this.props.companies.find(obj => obj.code === this.props.userCode);

    const params = {
      vatCode: this.props.vatCode.vatCode,
      companyId: company.id,
      isGenericVatCode: false,
      date: this.props.vatCode.startDate
    };
    this.props.doSimulation(params)
  };
 
  onCloseModal = () => {
    this.setState({ open: false });
    this.props.unloadSimulation();
  };

  createGoodTypeOptions(fieldValues) {
    return [
      { key: '', value: '', label: '', selected: (fieldValues.goodType || '') === '', disabled: true },
      ...goodTypes.map((goodType, key) => ({
        key: key.toString(),
        value: goodType,
        label: goodType,
        selected: (fieldValues.goodType || '') === goodType
      }))
    ];
  }

  createMainVATCodeOptions(fieldsDependentOnMainVATCodeValue) {
    return [
      { 
        key: '', 
        value: '', 
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodes_form_mainCode_UnknownMainVATCode"), 
        selected: fieldsDependentOnMainVATCodeValue.mainVATCode === '', 
        disabled: true 
      },
      { 
        key: mainVATCodes[0], 
        value: mainVATCodes[0], 
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodes_form_mainCode_OptionMainVATCode"), 
        selected: fieldsDependentOnMainVATCodeValue.mainVATCode === mainVATCodes[0] 
      },
      { 
        key: mainVATCodes[1], 
        value: mainVATCodes[1], 
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodes_form_mainCode_OptionSecondLineVATCode"), 
        selected: fieldsDependentOnMainVATCodeValue.mainVATCode === mainVATCodes[1] 
      },
      { 
        key: mainVATCodes[2], 
        value: mainVATCodes[2], 
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodes_form_mainCode_OptionThirdLineVATCode"), 
        selected: fieldsDependentOnMainVATCodeValue.mainVATCode === mainVATCodes[2] 
      },
      { 
        key: mainVATCodes[3], 
        value: mainVATCodes[3], 
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, "vatCodes_form_mainCode_OptionRecargo"), 
        selected: fieldsDependentOnMainVATCodeValue.mainVATCode === mainVATCodes[3] 
      }
    ];
  }

  createLineFlowTypeOptions(fieldValues) {
    return [
      { key: '', value: '', label: '', selected: (fieldValues.lineFlowType || '') === '', disabled: true },
      ...flowTypes.map((flowType, key) => ({
        key: key.toString(),
        value: flowType,
        label: flowType,
        selected: (fieldValues.lineFlowType || '') === flowType
      }))
    ];
  }

  createMiniOneStopShopOptions(fieldValues) {
    return [
      { key: '', value: '', label: '', selected: (fieldValues.miniOneStopShop || 0) === '', disabled: true },
      ...ossOptions.map((ossOption, key) => ({
        key: key.toString(),
        value: key.toString(),
        label: ossOption,
        selected: (fieldValues.miniOneStopShop || 0) === key
      }))
    ];
  }

  createICListingOptions(fieldsDependentOnMainVATCodeValue) {
    return [
      { key: '', value: '', label: '', selected: (fieldsDependentOnMainVATCodeValue.icListing || '') === '', disabled: true },
      ...ecListingOptions.map((ecOption, key) => ({
        key: key.toString(),
        value: ecOption,
        label: ecOption,
        selected: (fieldsDependentOnMainVATCodeValue.icListing || '') === ecOption
      }))
    ];
  }

  createRefundVATCodeOptions(fieldsDependentOnMainVATCodeValue) {
    return [
      { key: '', value: '', label: '', selected: (fieldsDependentOnMainVATCodeValue.refundVATCode || '') === '', disabled: true },
      ...refundVatCodeOptions.map((refundCodeOption, key) => ({
        key: key.toString(),
        value: refundCodeOption,
        label: refundCodeOption,
        selected: (fieldsDependentOnMainVATCodeValue.refundVATCode || '') === refundCodeOption
      }))
    ];
  }

  createDocumentsClearedOptions(fieldValues) {
    return [
      { key: '', value: '', label: '', selected: (fieldValues.documentsCleared || '') === '', disabled: true },
      ...reportingDates.map((reportOn, key) => ({
        key: key.toString(),
        value: reportOn,
        label: LANGUAGE_CONTROLLER.format(this.props.languageString, reportOn),
        selected: (fieldValues.documentsCleared || '') === reportOn
      }))
    ];
  }

  render() {
    log.debug('render(): ', this.props);

    const fieldValues = this.props.formData && this.props.formData.fieldValues;

    if (!fieldValues) {
      return (<div></div>);
    }

    const enableSalesDomesticReverseChargeRate = this.checkForSalesDomesticReverseChargeRate(fieldValues.lineFlowType, fieldValues.vatCodeFlow);
    const fieldsDependentOnMainVATCodeValue = this.applyMainVATCodeLogic(fieldValues);
    const transactionDescription = this.getTransactionDescription(fieldValues);

    const { open } = this.state;
    const extraCompanyProps = { disabled : this.props.createNew !== 'true'}; // enabling company selection for duplicate vat code creation screen SVR-14621
    const extraCountryProps = { disabled : this.props.createNew === 'true'}; // disabling country selection for duplicate vat code creation screen SVR-14621

    return(
      <form>
        <ReadOnlyWrapper>
          <fieldset>
            {isCreatingNew(this.props.createNew) && (
              <span>
                <ApplicationMessages messageType="applicationError"/>
              </span>
            )}
            <s-row>
            <s-col span="6">
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_USER_CODE]}
              >
                <label className="mt10"><LanguageStringResolver string="vatCodes_form_company"/>:</label>
                <SingleCompanySelector
                        companyList={this.props.companies}
                        fieldName={'userCode'}
                        selectionHandler={this.onCompanyFieldChange.bind(this)}
                        selectedCompanyId={fieldValues.userCode || ''}
                        valueCompanyCode={true}
                        customOptions={[{body:LANGUAGES_CONTROLLER.format(this.props.languages, "vatCodes_Generic_User"), value:'Generic'}]}
                        hideDefaultValue={true}
                        extraProps={extraCompanyProps}
                    />
              </HighlightOnInAppMessage>
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_VAT_CODE]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_vatCode'/>:</label>
                <div>
                  {shouldShowSimulation(this.props.createNew, this.props.userCode) ? (
                    <div className="VATCode-container">
                      <input className="VATCode" value={fieldValues.vatCode || ''} name='vatCode' onChange={this.onFieldChange.bind(this)}/>
                      <a className="tertiary ml10" onClick={this.onOpenModal}><LanguageStringResolver string='vatCodes_form_simulate_button'/></a>
                      <div className="clear"></div>
                    </div>
                  ) : (
                    <input value={fieldValues.vatCode || ''} name='vatCode' onChange={this.onFieldChange.bind(this)}/>
                  )}
                </div>
              </HighlightOnInAppMessage>
              <Modal classNames={MODAL_CLASSNAMES} open={open} onClose={this.onCloseModal} center>
                <h2><LanguageStringResolver string='vatCodes_form_simulate_title'/></h2>
                <div className="VATCode-Details-modal">
                  <VATCodeSimulation
                    vatCodeSimulator={this.props.vatCodeSimulator}
                  />
                </div>
              </Modal>
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COUNTRY]}>
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_country'/>:</label>
                <SingleCountrySelector disableFilterByLicence={true} countryList={this.props.countryList} fieldName={'country'} selectedCountryCode={fieldValues.country || ''} extraProps={extraCountryProps} selectionHandler={this.onCountryChange.bind(this)}/>
              </HighlightOnInAppMessage>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_vatRate'/>:</label>
              <NumberField isRational={true} defaultValue={'0'} value={(fieldValues.vatRate === "NaN") ?(''):(fieldValues.vatRate)  || ''} name='vatRate' onChange={this.onFieldChange.bind(this)}/>
              <input
                className="mt10"
                type="checkbox"
                title=''
                name='vatRateType'
                checked={fieldValues.vatRateType !== 'Normal'}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="checkbox mt10"><LanguageStringResolver string='vatCodes_form_vatRateType'/></label>
              <div className="clear"></div>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_reversedVATRateDomestic'/>:</label>
              <NumberField isRational={true} defaultValue={'0'} value={(fieldValues.reversedVATRateDomestic !== undefined) ? fieldValues.reversedVATRateDomestic : ''} name='reversedVATRateDomestic' onChange={this.onFieldChange.bind(this)} disabled={!enableSalesDomesticReverseChargeRate}/>
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_combinationIDInvoice'/>:</label>
                <NumberField value={(fieldValues.combinationIDInvoice !== undefined) ? fieldValues.combinationIDInvoice : ''} name='combinationIDInvoice' onChange={this.onFieldChange.bind(this)}/>
              </HighlightOnInAppMessage>
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID_CREDIT]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_combinationIDCredit'/>:</label>
                <NumberField value={(fieldValues.combinationIDCredit !== undefined) ? fieldValues.combinationIDCredit : ''} name='combinationIDCredit' onChange={this.onFieldChange.bind(this)}/>
              </HighlightOnInAppMessage>
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_deductibleVAT'/>:</label>
                <NumberField extraProps={{className: withFullStoryExclude()}} isRational={true} defaultValue={'0'} value={fieldValues.deductibleVAT || ''} name='deductibleVAT' onChange={this.onFieldChange.bind(this)}
              />
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_GOODTYPE]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_goodType'/>:</label>
                <SSelect
                  inputId="vat-code-good-type"
                  className={withFullStoryExclude()}
                  optionsList={this.createGoodTypeOptions(fieldValues)}
                  multiple={false}
                  onS-select={(e) => {
                    const syntheticEvent = {
                      target: { name: 'goodType', value: e.detail.item.value }
                    };
                    this.onFieldChange(syntheticEvent);
                  }}
                />
              </HighlightOnInAppMessage>
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_MAIN_VAT_CODE]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_mainCode'/>:</label>
                <SSelect
                  inputId="vat-code-main-code"
                  className={withFullStoryExclude()}
                  optionsList={this.createMainVATCodeOptions(fieldsDependentOnMainVATCodeValue)}
                  multiple={false}
                  onS-select={(e) => {
                    const syntheticEvent = {
                      target: { name: 'mainVATCode', value: e.detail.item.value }
                    };
                    this.onFieldChange(syntheticEvent);
                  }}
                />
              </HighlightOnInAppMessage>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_lineFlowType'/>:</label>
              <SSelect
                inputId="vat-code-line-flow-type"
                optionsList={this.createLineFlowTypeOptions(fieldValues)}
                multiple={false}
                onS-select={(e) => {
                  const syntheticEvent = {
                    target: { name: 'lineFlowType', value: e.detail.item.value }
                  };
                  this.onFieldChange(syntheticEvent);
                }}
              />
              {/* Currently the comments are not shown - ticket raised VR-4903 */}
              <HighlightOnInAppMessage
                scopes={[this.props.UID_FORM_NAME]}
                messageIds={[ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_IVAT_TRANSACTION_ID]}
              >
                <label className="mt10"><LanguageStringResolver string='vatCodes_form_ivatTransactionId'/>:</label>
                <NumberField title={transactionDescription} value={(fieldValues.ivatTransactionID !== undefined) ? fieldValues.ivatTransactionID : ''} name='ivatTransactionID' onChange={this.onFieldChange.bind(this)}/>
              </HighlightOnInAppMessage>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_startDate'/>:</label>
              <input type="date" value={fieldValues.startDate} name='startDate' onChange={this.onFieldChange.bind(this)}/>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_endDate'/>:</label>
              <input type="date" value={fieldValues.endDate} name='endDate' onChange={this.onFieldChange.bind(this)}/>
              <input className="mt10 mb10 checkbox" type="checkbox" title='' name='recalculateVAT' checked={fieldsDependentOnMainVATCodeValue.recalculateVAT === 1} onChange={this.onFieldChange.bind(this)} disabled={fieldsDependentOnMainVATCodeValue.disableRecalculateVAT}/>
              <label className="mt10 mb10 checkbox"><LanguageStringResolver string='vatCodes_form_recalculateVAT'/></label>
              <div className="clear"></div>
            </s-col>

            {/* Second column */}
            <s-col span="6">
              <legend><LanguageStringResolver string='vatCodes_form_itemType'/>:</legend>
              <input
                type="radio"
                name="itemType"
                value='Good'
                checked={fieldValues.itemType === 'Good'}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="radio"><LanguageStringResolver string='vatCodes_form_itemType_good'/></label>
              <input
                type="radio"
                name="itemType"
                value='Service'
                checked={fieldValues.itemType === 'Service'}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="radio"><LanguageStringResolver string='vatCodes_form_itemType_service'/></label>
              <div className="clear"></div>
              <legend className="mt10"><LanguageStringResolver string='vatCodes_form_vatCodeFlow'/>:</legend>
              <input
                type="radio"
                name="vatCodeFlow"
                value='In'
                checked={fieldValues.vatCodeFlow === 'In'}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="radio"><LanguageStringResolver string='vatCodes_form_vatCodeFlow_in'/></label>
              <input
                type="radio"
                name="vatCodeFlow"
                value='Out'
                checked={fieldValues.vatCodeFlow === 'Out'}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="radio"><LanguageStringResolver string='vatCodes_form_vatCodeFlow_out'/></label>
              <div className="clear"></div>
              <input
                className="mt10"
                type="checkbox"
                title='Tick to report transactions as Intrastat Incoming.'
                name='intrastatIn'
                checked={fieldsDependentOnMainVATCodeValue.intrastatIn === true}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_intrastatIn'/></label>
              <div className="clear"></div>
              <input
                className={withFullStoryExclude('mt10')}
                type="checkbox"
                title='Tick to report transactions as Intrastat Outgoing.'
                name='intrastatOut'
                checked={fieldsDependentOnMainVATCodeValue.intrastatOut === true}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_intrastatOut'/></label>
              <div className="clear"></div>
              <input
                className={withFullStoryExclude('mt10')}
                type="checkbox"
                title='Tick to report transactions as a Reverse Charge.'
                name='reverseChargeDocument'
                checked={fieldValues.reverseChargeDocument === 1}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_reverseChargeDocument'/></label>
              <div className="clear"></div>
              <input
                className="mt10"
                type="checkbox"
                title='Tick to indicate Revision VAT Code where Taxable Basis is converted to VAT.'
                name='revisionVATCodeTaxBConvertedToVAT'
                checked={fieldValues.revisionVATCodeTaxBConvertedToVAT === 1}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_revisionVATCodeTaxBConvertedToVAT'/></label>
              <div className="clear"></div>
              <input
                className="mt10"
                type="checkbox"
                title='Tick to report transactions as Fixed Assets.'
                name='fixedAsset'
                checked={fieldValues.fixedAsset === 1}
                onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_fixedAsset'/></label>
              <div className="clear"></div>
               <label className="mt10"><LanguageStringResolver string='vatCodes_form_miniOneStopShop'/>:</label>
                <SSelect
                  inputId="vat-code-mini-one-stop-shop"
                  className={withFullStoryExclude()}
                  optionsList={this.createMiniOneStopShopOptions(fieldValues)}
                  multiple={false}
                  onS-select={(e) => {
                    const syntheticEvent = {
                      target: { name: 'miniOneStopShop', value: e.detail.item.value }
                    };
                    this.onFieldChange(syntheticEvent);
                  }}
                />
              <div className="clear"></div>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_icListing'/>:</label>
              <SSelect
                inputId="vat-code-ic-listing"
                className={withFullStoryExclude()}
                optionsList={this.createICListingOptions(fieldsDependentOnMainVATCodeValue)}
                multiple={false}
                disabled={fieldsDependentOnMainVATCodeValue.disableECListing}
                onS-select={(e) => {
                  const syntheticEvent = {
                    target: { name: 'icListing', value: e.detail.item.value }
                  };
                  this.onFieldChange(syntheticEvent);
                }}
              />
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_refundVatCodeOptions'/>:</label>
              <SSelect
                inputId="vat-code-refund-vat-code"
                optionsList={this.createRefundVATCodeOptions(fieldsDependentOnMainVATCodeValue)}
                multiple={false}
                disabled={fieldsDependentOnMainVATCodeValue.disableRefundVATCode}
                onS-select={(e) => {
                  const syntheticEvent = {
                    target: { name: 'refundVATCode', value: e.detail.item.value }
                  };
                  this.onFieldChange(syntheticEvent);
                }}
              />
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_refundType'/>:</label>
              <input value={fieldValues.refundType || ''} name='refundType' onChange={this.onFieldChange.bind(this)}/>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_proRata'/>:</label>
              <NumberField isRational={true} defaultValue={'0'} value={fieldValues.proRata || ''} name='proRata' onChange={this.onFieldChange.bind(this)}/>
              <input
                className="mt10 checkbox"
                type="checkbox"
                title='Tick to indicate Yes, clear for No'
                name='vatCodeForVATUnit' checked={fieldValues.vatCodeForVATUnit === 1} onChange={this.onFieldChange.bind(this)}
              />
              <label className="mt10 checkbox"><LanguageStringResolver string='vatCodes_form_vatCodeForVATUnit'/></label>
              <div className="clear"></div>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_documentsCleared'/>:</label>
              <SSelect
                inputId="vat-code-documents-cleared"
                optionsList={this.createDocumentsClearedOptions(fieldValues)}
                multiple={false}
                disabled={fieldsDependentOnMainVATCodeValue.disableDocumentsCleared}
                onS-select={(e) => {
                  const syntheticEvent = {
                    target: { name: 'documentsCleared', value: e.detail.item.value }
                  };
                  this.onFieldChange(syntheticEvent);
                }}
              />
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_extraReports'/>:</label>
              <textarea value={fieldValues.extraReports || ''} name='extraReports' onChange={this.onFieldChange.bind(this)}/>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_extraDescription'/>:</label>
              <textarea value={fieldValues.extraDescription || ''} name='extraDescription' onChange={this.onFieldChange.bind(this)}/>
              <label className="mt10"><LanguageStringResolver string='vatCodes_form_withholdingRate'/>:</label>
              <NumberField isRational={true} defaultValue={'0'} value={fieldValues.withholdingRate || ''} name='withholdingRate' onChange={this.onFieldChange.bind(this)} />
            </s-col>
          </s-row>
          <a className="button primary" onClick={this.onSubmitForm.bind(this)}>
            <LanguageStringResolver string={getButtonLabel(this.props.createNew)}/>
          </a>
          <a className="button secondary" onClick={this.onCancelDuplicateVatCode.bind(this)} excludeFromReadonly={true}>
            <LanguageStringResolver string='vatCodes_form_button_cancel'/>
          </a>
        </fieldset>
        </ReadOnlyWrapper>
      </form>
    )
  }

  componentWillUnmount() {
    this.log.debug('componentWillUnMount: ', this.props.UID_FORM_NAME);
    this.props.doDestroyForm(this.props.UID_FORM_NAME);
  }

  UNSAFE_componentWillMount() {
    this.log.debug('componentWillMount(): ', this.props.UID_FORM_NAME);
    this.props.doInitialiseForm(this.props.UID_FORM_NAME, this.props.vatCode);
    log.clearAllDictionaryErrors();
  }

  onFieldChange(evt) {
    let value = evt.target.value;
    const field = evt.target.name;
    
    // Checkboxes need some help and ours can be boolean or binary (nice!)
    if (evt.target.type === 'checkbox') {
      const checkboxResult = getCheckboxValue(field, evt.target.checked);
      value = checkboxResult.value;
      
      if (!checkboxResult.isHandled) {
        this.log.debug('onFieldChange: Unhandled checkbox: ', field);
      }
    }
    
    this.props.onFieldChange(this.props.UID_FORM_NAME, field, value);
    
    // Clear dictionary errors for specific fields
    const errorMessage = ERROR_MESSAGE_FIELDS[field];
    if (errorMessage) {
      this.log.clearDictionaryError(errorMessage);
    }
  }

    onCompanyFieldChange(companyObj) {
      const entries = Object.entries(companyObj);
      if (entries.length === 0) return;
      
      const [key, value] = entries[0];

      this.props.onFieldChange(this.props.UID_FORM_NAME, key, value);
      this.log.clearDictionaryError(ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_USER_CODE);
    }

    onCountryChange(keyValue) {
      log.debug('onCountryChange(): ', keyValue);
      
      const entries = Object.entries(keyValue);
      if (entries.length === 0) return;
      
      const [fieldName, value] = entries[0];

      if (keyValue !== '' && keyValue !== undefined) {
        this.log.clearDictionaryError(ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COUNTRY);
      }

      this.props.onFieldChange(this.props.UID_FORM_NAME, fieldName, value);
      this.validateField(keyValue, ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COUNTRY);
    }

    validateField(field, errorCode) {
      return new Promise((resolve, reject) => {
        if (field === undefined || field === '') {
          this.log.setDictionaryMessage(errorCode);
          reject();
        } else {
          resolve();
        }
      });
    }

  validateAll() {
    this.log.clearAllDictionaryErrors();

    const fieldValues = this.props.formData.fieldValues;
    const isGeneric = fieldValues.userCode === 'Generic';

    const fields = [
      { name: fieldValues.userCode, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_USER_CODE },
      { name: fieldValues.vatCode, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_VAT_CODE },
      { name: fieldValues.goodType, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_GOODTYPE },
      { name: fieldValues.mainVATCode, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_MAIN_VAT_CODE },
      { name: fieldValues.ivatTransactionID, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_IVAT_TRANSACTION_ID }
    ];

    if (!isGeneric) {
      fields.push(
        { name: fieldValues.country, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COUNTRY },
        { name: fieldValues.combinationIDInvoice, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID },
        { name: fieldValues.combinationIDCredit, errorCode: ALL_MESSAGES.BLANK_REPORTINGCOMBINATION_COMBINATION_ID_CREDIT }
      );
    }

    return Promise.all(
      fields.map(f => this.validateField(f.name, f.errorCode))
    );
  }


  onSubmitForm() {
    const action = getSubmitAction(this.props.createNew, this.props.duplicateVatCode);

    this.validateAll()
      .then(() => {
        this.log.debug('onSubmitForm(): ', this.props.formData);
        this.props.submitHandler(action, this.props.formData);
      })
      .then(() => this.props.doFormSubmitted(this.props.UID_FORM_NAME))
      .then(() => this.props.doResetForm(this.props.UID_FORM_NAME));
  }

  onCancelDuplicateVatCode()
  {
    this.props.cancelHandler();
  }
}


function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  const UID_FORM_NAME = FORM_NAME + '_' + (props.id !== undefined ? props.id : 'PAGE');
  const stateProps = {
    vatCodeDetails : (state.vatCodeSimulator && state.vatCodeSimulator.vatCodeDetails) || []
};
  return {
    formData: (state.managedUxForms && state.managedUxForms.forms[UID_FORM_NAME]),
    companies: (state.companies && state.companies.data ) || [],
    UID_FORM_NAME: UID_FORM_NAME,
    stateProps: stateProps,
    countryList : (state.content && state.content.contentData && state.content.contentData.countryList)
  };
  
}



function mapDispatchersToProps(dispatch) {
  return {
    // Standard form actions
    doInitialiseForm: (rowFormName, initialValues) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(rowFormName, initialValues));
    },
    doResetForm: (rowFormName) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(rowFormName));
    },
    doClearForm: (rowFormName) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(rowFormName));
    },
    onFieldChange: (rowFormName,fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(rowFormName, fieldName, value));
    },
    doFormSubmitted: (rowFormName) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(rowFormName));
    },
    doDestroyForm: (rowFormName) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(rowFormName));
    },
    doSimulation: (params) => {
      dispatch(VATCODE_SIMULATOR_CONTROLLER.doVATCodeSimulation(params));
    },
    unloadSimulation: () => {
      dispatch(VATCODE_SIMULATOR_CONTROLLER.doUnload());
    }
  }
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(VatCodeForm);
